var map = {
	"./algorithm.svg": 665,
	"./big-screen.svg": 666,
	"./collect.svg": 667,
	"./dataAnalysis.svg": 668,
	"./dataQuality.svg": 669,
	"./defalut.svg": 670,
	"./digitalScreen.svg": 671,
	"./factory.svg": 672,
	"./flow.svg": 673,
	"./forms.svg": 674,
	"./home.svg": 675,
	"./industryModel.svg": 676,
	"./model.svg": 677,
	"./property.svg": 678,
	"./sheet.svg": 679,
	"./system.svg": 680,
	"./task.svg": 681,
	"./tpl.svg": 682,
	"./warning.svg": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 310;